import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import './DlUnitEdit.scss';
import { Form, Button } from 'react-bootstrap';
import { getGroup, newGroupInit, saveGroup } from "./../../actions";
import DlGroup from '../../models/DlGroup';


const mapStateToProps = (state) => ({
    dlGroup: state.dlGroup.dlGroup,
    dlGroupSlug: state.dlGroup.dlGroupSlug
});

const mapDispatchToProps = (dispatch) => ({
  getGroup: (payload) => dispatch(getGroup(payload)),
  newGroupInit: () => dispatch(newGroupInit()),
  saveGroup: (payload) => dispatch(saveGroup(payload)),  
});

const DlGroupEdit = ({ match, getGroup, newGroupInit, dlGroup, dlGroupSlug, saveGroup }) => {
    const slug = ( 'slug' in match.params ? match.params.slug : '' );
    let fRefSlug = React.createRef();
    let fRefFCondKey = React.createRef();
    let fRefFCondVal = React.createRef();
    let [fCond, setFCond] = useState({});    
    
    fCond = Object.keys(fCond).length == 0 && typeof dlGroup.fCond !== 'undefined' && Object.keys(dlGroup.fCond).length > 0 ? { ...dlGroup.fCond } : fCond;

    const saveItem = (ev) => {
        let item = new DlGroup();
        fCond = typeof fCond !== 'undefined' ? fCond : {};
        item.obSet({ fCond, slug: fRefSlug.current.value });
        // ev.preventDefault();
        saveGroup({ itemId: dlGroup.id, item });
    };
    const deleteFCond = (key) => {
        delete(fCond[key]);
        setFCond({ ...fCond });
    };
    const addFCond = () => {
        const key = fRefFCondKey.current.value;
        const val = fRefFCondVal.current.value;

        if (key != '') {
            if (!fCond.hasOwnProperty(key)) {
                fCond[key] = val;   
                setFCond({ ...fCond });
                fRefFCondKey.current.value = '';
                fRefFCondVal.current.value = '';                
            } else {
                alert('Naziv polja je vec u uslovu')
            }
        } else {
            alert('Naziv polja ne sme biti prazan')
        }      
    };
    useEffect(function() {
        if (slug!=='') {
            getGroup(slug);
            fRefSlug.current.value = slug;
        } else {
            newGroupInit();
        }
    }, [dlGroupSlug]);

    let fCondLi = [];
    for (const key in fCond) {
        if (fCond.hasOwnProperty(key)) {
            fCondLi.push(<div key={key}>
                <Form.Group>
                    <Form.Control type="text" defaultValue={ key } disabled />
                    <Form.Control type="text" defaultValue={ fCond[key] } style={{ marginTop: '0.5em' }} disabled />
                    <Button variant="secondary" type="button" onClick={() => deleteFCond(key)} style={{ marginTop: '0.5em' }}>obrisi</Button>
                </Form.Group>
            </div>);            
        }
    }

    return (
        <Form style={{ 'marginLeft': '0%' }} onSubmit={saveItem}>
            <Form.Group controlId="formBasicSearch">
                <Form.Label>Slug</Form.Label>
                <Form.Control type="text" ref={fRefSlug} placeholder="slug" defaultValue={dlGroup.slug} />
            </Form.Group>
            <Form.Group controlId="formBasicSearch">
                <Form.Label>Polja uslova:</Form.Label>
                { fCondLi }
                <Form.Group>
                    <Form.Control type="text" ref={fRefFCondKey} placeholder="naziv" />
                    <Form.Control type="text" ref={fRefFCondVal} placeholder="vrednost" style={{ marginTop: '0.5em' }} />
                    <Button variant="secondary" type="button" onClick={addFCond} style={{ marginTop: '0.5em' }}>
                        Dodaj
                    </Button>
                </Form.Group>
            </Form.Group>
            <Button variant="primary" type="button" onClick={saveItem} style={{ marginTop: '1em' }}>
            OK
            </Button>
            {/* { JSON.stringify(fCond) } */}
        </Form>

    );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlGroupEdit);
